/**
 * Calendar create context is required for following reasons:
 *  - `react-day-picker` has a prop `components` for customizing
 *     any of the child components like `Day` etc.
 *  - When a function is passed to the component then it is leading
 *    to focus issue on navigting the navigation bar controls.
 *    https://github.com/gpbl/react-day-picker/issues/1486
 *  - Hence we had to create the below context provider to share
 *    the data between the `Calendar` component and `NavigationBar`
 *    component.
 */
import React from "react";
export const CalendarContext = /*#__PURE__*/React.createContext();